import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-specific-cpts',
  templateUrl: './company-specific-cpts.component.html',
  styleUrls: ['./company-specific-cpts.component.css']
})
export class CompanySpecificCptsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
